import { AddressFull } from '../../../types/opzet';

export type SelectedGeoLocationPayload = {
  data: AddressFull | null;
};

export const SET_SELECTED_GEO_LOCATION = 'SET_SELECTED_GEO_LOCATION';
export function setSelectedGeoLocation(payload: SelectedGeoLocationPayload) {
  return {
    type: SET_SELECTED_GEO_LOCATION,
    payload,
  };
}
